module.exports = __webpack_public_path__ + "static/media/document.8a7e8d89.svg";